export enum IndexedDBErrorKeys {
  AbortError = "AbortError",
  ConstraintError = "ConstraintError",
  QuotaExceededError = "QuotaExceededError",
  UnknownError = "UnknownError",
  VersionError = "VersionError",
  ItemNotFound = "ItemNotFound",
  FragmentOverlap = "FragmentOverlap",
  SourceFileNotFound = "SourceFileNotFound"
};